// First usable four-digit year from a list of date strings.
export function yearFrom(...dates) {
  const date = dates.find(Boolean);
  const year = Number(String(date || "").slice(0, 4));
  return Number.isInteger(year) && year > 1900 ? year : null;
}
